import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import InnerRouter from '../router/innerRouter';
import stores from '../../stores';

class PortalMainRouter extends Component {

    render() {
        
        return(
            <Provider {...stores}>
                <HashRouter hashType='slash'>
                    <InnerRouter />
                </HashRouter>
            </Provider>
        );
    }
}

export default PortalMainRouter;

if (process.env.NODE_ENV !== 'production') {
    window.stores = stores;
}